exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "adp-icon-button{padding:0;display:inline-block;vertical-align:middle}adp-icon-button.font-regular .icon-btn-text{font-family:ProximaNova-Regular,Arial,Helvetica,sans-serif}adp-icon-button a{display:flex;align-items:center;color:#4d4d4d;cursor:pointer;font-size:0;transition:.3s ease}adp-icon-button a.grey{color:#4d4d4d;font-family:ProximaNova-Bold,Arial,Helvetica,sans-serif;text-transform:uppercase}adp-icon-button a.grey:hover{color:#000}adp-icon-button a.blue{color:#1a8099;font-family:ProximaNova-Semibold,Arial,Helvetica,sans-serif}adp-icon-button a.blue .icon-btn-text{font-size:13px;display:inline-block;margin-top:0}adp-icon-button a.attachment .ico{padding-left:5px;padding-right:0;vertical-align:top;transform:rotate(180deg)}adp-icon-button a .ico{margin-right:1px}adp-icon-button .ico,adp-icon-button .icon{display:inline-block;vertical-align:top;margin-right:2px!important;padding-right:0}adp-icon-button .icon{font-size:14px}adp-icon-button .icon-btn-text{display:inline-block;font-size:12px;vertical-align:top}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/less-loader!./src/app/components/adpIconButton/adpIconButton.less
// module id = 558
// module chunks = 0